<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h2 class="mb-5 primary--text">Gerenciamento de Permissões</h2>
            </v-col>
        </v-row>

        <v-layout class="d-flex justify-space-between flex-wrap mb-4">
            <div class="d-flex" style="gap: 14px;">
                <v-btn class="transition" color="primary" rounded @click="adicionarPermissao">
                    <v-icon small style="margin-right: 10px;">add</v-icon>
                    ADICIONAR PERMISSÃO
                </v-btn>
                <v-btn class="transition" color="primary" rounded @click="toggleFiltros">
                    <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                    FILTRAR POR
                    <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                </v-btn>
            </div>
            <div class="d-flex">
                <v-btn color="primary" class="justify-end" @click="exportarExcel">
                    <v-icon left size="18">
                        mdi-file-chart
                    </v-icon>
                    SALVAR RELATÓRIO
                </v-btn>
            </div>
        </v-layout>
        <collapse-transition>
            <m-form ref="filter" v-show="filter_open" class="mt-4 ml-2">
                <v-row>
                    <v-col cols="6" class="mb-4">
                        <v-select label="Permissão Administrativa:" placeholder="Selecione a permissão administrativa" outlined
                                  menu-props="offsetY" hide-details v-model="filters.perfil_permissao_nome" :items="adminPermission"
                                  item-text="nome" item-value="nome"
                        />
                    </v-col>
                    <v-col cols="6" class="mb-4">
                        <v-select label="Status:" placeholder="Selecione o status da permissão" outlined
                                  menu-props="offsetY" hide-details v-model="filters.status" :items="status_admin"
                                  item-text="label" item-value="value"
                        />
                    </v-col>
                    <v-col cols="6" class="mb-4">
                        <v-select label="Perfil Relacionado:" placeholder="Selecione o perfil relacionado" outlined
                                  menu-props="offsetY" hide-details v-model="filters.perfil_relacionado_nome" :items="adminProfiles"
                                  item-text="nome" item-value="nome"
                        />
                    </v-col>
                </v-row>
                <v-row class="justify-space-between mt-4">
                    <v-col cols="6" md="3">
                        <v-btn color="secondary" block @click="limpar">
                            Limpar
                        </v-btn>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-btn color="primary" block @click="filtrar">
                            Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </m-form>
        </collapse-transition>
        <v-row>
            <v-col cols="12">
                <DataTable
                        ref="datatable"
                        url="/painel/backoffice/permissions"
                        class="pt-2"
                        :headers="headers"
                        :filter="filterTable"
                >
                    <template v-slot:items="{item}">
                        <td>
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes"
                                           v-bind="attrs"
                                           style="margin: 10px 0px;
                                           padding: 5px;
                                           min-width: 48px;"
                                           v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <v-list-item-title>Editar</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{ item.perfil_permissao_nome || ' - ' }}</td>
                        <td>{{ item.status === null || item.status === undefined ? '-' : (item.status === 1 || item.status === true ? 'Ativo' : 'Inativo') }}</td>
                        <td>{{ item.perfil_relacionado_nome || ' - ' }}</td>
                    </template>
                </DataTable>
            </v-col>
        </v-row>
        <DialogPermissoesPerfil
                v-model="showDialog"
                :schema="dialogSchema"
                :checkboxes="permissionCheckboxes"
                :is-edit="isEdit"
                :perfil="perfilEditando"
                @submit="salvarPermissoes"
        />
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../plugins/alerts_types'
  import DialogPermissoesPerfil from '@/dialogs/DialogPermissoesPerfil.vue'
  import { StatusUser } from '@/plugins/constants'
  import * as Qs from 'qs'

  export default {
    name: 'GerenciamentoPermissoes',
    components: { DialogPermissoesPerfil },
    data () {
      return {
        filterTable: {},
        filters: {
          perfil_permissao_nome: null,
          status: null,
          perfil_relacionado_nome: null
        },
        pagination: {
          sortBy: [], descending: []
        },
        filter_open: false,
        headers: [
          { text: 'Ações', value: '', sortable: false, class: 'acoes-header' },
          { text: 'Permissão Administrativa', value: 'perfil_permissao_nome', sortable: true },
          { text: 'Status', value: 'status', sortable: true },
          { text: 'Perfil Relacionado', value: 'perfil_relacionado_nome', sortable: true }
        ],
        showDialog: false,
        isEdit: false,
        perfilEditando: null,
        permissionCheckboxes: [],
        adminProfiles: [],
        adminPermission: [],
        allPermisions: [],
        status_admin: StatusUser.map(item => ({ label: item.text, value: item.value })),
        saving: false

      }
    },
    computed: {
      dialogSchema () {
        return [
          {
            type: 'select',
            model: 'perfil',
            props: {
              label: 'Perfil Relacionado',
              items: this.adminProfiles,
              'item-text': 'nome',
              'item-value': 'id_perfil',
              placeholder: 'Selecione um perfil relacionado',
              'return-object': false,
              clearable: true,
              'no-data-text': 'Nenhum perfil disponível'
            }
          },
          {
            type: 'select',
            model: 'status',
            props: {
              label: 'Status',
              items: StatusUser,
              'item-text': 'text',
              'item-value': 'value'
            }
          }
        ]
      },
      params () {
        return {
          pagination: this.pagination
        }
      }
    },
    async created () {
      await Promise.all([
        this.loadFuncionalidades(),
        this.loadAdminProfiles(),
        this.loadAdminPermission()
      ])
    },
    methods: {
      toggleFiltros () {
        this.filter_open = !this.filter_open
      },
      async loadFuncionalidades () {
        try {
          const response = await this.$http.get('/painel/backoffice/todas-funcionalidades-perfil')

          const funcionalidades = response.data.items || response.data

          this.permissionCheckboxes = funcionalidades.map(item => ({
            label: item.nome,
            value: item.id_funcionalidade
          }))
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar funcionalidades: ' + (error.response?.data?.error || error.message))
          this.permissionCheckboxes = []
        }
      },
      async loadAdminProfiles () {
        try {
          const response = await this.$http.get('/painel/backoffice/perfis-administrativos-permitidos')

          this.adminProfiles = response.data || []
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar perfis administrativos: ' + (error.response?.data?.error || error.message))
          this.adminProfiles = []
        }
      },
      async loadAdminPermission () {
        try {
          const response = await this.$http.get('/painel/backoffice/permissoes-administrativas')

          this.adminPermission = response.data || []
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar permissões administrativas: ' + (error.response?.data?.error || error.message))
          this.adminPermission = []
        }
      },
      async adicionarPermissao () {
        this.isEdit = false
        this.perfilEditando = null

        this.showDialog = true
      },
      async salvarPermissoes ({ nomes, fields, checkboxes }) {
        this.saving = true

        try {
          let response
          if (this.isEdit && this.perfilEditando.id_perfil) {
            response = await this.$http.put(`/painel/backoffice/permissions/${this.perfilEditando.id_perfil}`, {
              nomes: nomes.filter(nome => nome.trim()),
              fields,
              checkboxes
            })
          } else {
            response = await this.$http.post('/painel/backoffice/permissions', {
              nomes: nomes.filter(nome => nome.trim()),
              fields,
              checkboxes
            })
          }

          if (response.data.success) {
            notification(AlertTypes.SUCCESS, response.data.message)

            if (this.$refs.datatable) {
              this.$refs.datatable.reload()
              this.loadAdminPermission()
            }

            this.showDialog = false
          }
        } catch (error) {
          let errorMessage = error.response?.data?.error || error.message
          notification(AlertTypes.ERROR, errorMessage)

          if (error.response?.data?.errors) {
          }
        } finally {
          this.saving = false
        }
      },
      exportarExcel () {
        const filtros = { ...this.filters }
        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        try {
          window.open(`${this.ws}/gerenciamento_permissoes/exportar?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      async editar (item) {
        this.isEdit = true

        this.perfilEditando = {
          ...item,
          selectedPermissions: this.getSelectedPermissionsFromPerfil(item)
        }
        this.showDialog = true
      },
      getSelectedPermissionsFromPerfil (perfil) {
        return (perfil.gerenciamento_permissoes || [])
          .filter(f => f.permitido)
          .map(f => f.id_funcionalidade)
      },
      filtrar () {
        this.filterTable = { ...this.filters }
      },
      limpar () {
        this.filters = {
          perfil_permissao_nome: null,
          status: null,
          perfil_relacionado_nome: null
        }
        this.filtrar()
        this.filter_open = false
      }
    }
  }
</script>

<style scoped>
.acoes-header {
    margin-left: 10px !important;
}

.v-btn.transition {
    transition: all 0.3s ease;
}

.v-btn.transition:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}

::v-deep th:first-child {
  max-width: 100px;
  padding-left: 15px;
}
</style>
